import React from 'react';
import Box from '@mui/material/Box';

import NowPlaying from '../components/NowPlaying';
import UpNextStrip from '../components/UpNextStrip';
import SongHistory from '../components/SongHistory';
import HomeShowsPreview from '../components/HomeShowsPreview';
import HomeFeedPreview from '../components/HomeFeedPreview';
import ScrollFadeBox from '../components/ScrollFadeBox';
import { useOnlineStatusContext } from '../components/OnlineStatusContext';

const FEED_PANEL_WIDTH = 280;
const FEED_PANEL_GAP = 24;

function Home() {
  const { bannerOffset } = useOnlineStatusContext();

  return (
    <Box sx={{ paddingBottom: '8rem' }}>
      <Box sx={{ paddingRight: { md: `${FEED_PANEL_WIDTH + FEED_PANEL_GAP}px` } }}>
        <NowPlaying />

        <UpNextStrip />

        {/* Just Missed lives in the global left sidebar on desktop; shown here only when stacked on mobile */}
        <Box sx={{ display: { xs: 'block', md: 'none' }, marginTop: 4 }}>
          <SongHistory carousel />
        </Box>

        <Box sx={{ marginTop: 4 }}>
          <HomeShowsPreview />
        </Box>

        {/* Feed preview lives in a fixed right-hand panel on desktop; shown here only when stacked on mobile */}
        <Box sx={{ display: { xs: 'block', md: 'none' }, marginTop: 4 }}>
          <HomeFeedPreview carousel />
        </Box>
      </Box>

      <Box
        sx={{
          display: { xs: 'none', md: 'block' },
          position: 'fixed',
          top: 64 + bannerOffset,
          right: 0,
          bottom: 66,
          width: FEED_PANEL_WIDTH,
          zIndex: 1100,
          transition: 'top 0.25s ease',
        }}
      >
        <ScrollFadeBox
          sx={{ position: 'absolute', inset: 0 }}
          scrollSx={{ paddingRight: 2 }}
        >
          <HomeFeedPreview />
        </ScrollFadeBox>
      </Box>
    </Box>
  );
}

export default Home;
